import posthog from 'posthog-js';

type EventProperties = Record<string, string | number | boolean | null | undefined>;

const captureEvent = (event: string, properties?: EventProperties) => {
  posthog.capture(event, properties);
};

// PostHog only captures $pageview on full page loads, so screens reached through
// client-side navigation (history.push) have to report their own page view.
const initialPathname = window.location.pathname;

export const captureClientSidePageview = () => {
  if (window.location.pathname !== initialPathname) posthog.capture('$pageview');
};

export default captureEvent;
